<app-workspace-common-side-panel *ngIf="readyForWidgets" [config]="config" [legends]="data.legends"
    [datasetDescription]="datasetDescription"></app-workspace-common-side-panel >
